import axiosRequest from "axios";
import store from "@/store";
import router from "@/router";
import cookie from "vue-cookies";
// import store from "../store/index"
import Vue from "vue";
import i18n from "@/libs/i18n/i18n";
const axios = axiosRequest.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    crossDomain: "true",
    // 'Access-Control-Allow-Origin': 'All',
    // 'Access-Control-Allow-Credentials': 'false',
    "Content-Type": "application/json",
  },
  //  withCredentials: true
});
// const getAuthToken = () =>cookie.get('token') ? `Bearer ${cookie.get('token')}` : null;
const getAuthToken = () =>
  localStorage.getItem("token")
    ? `Bearer ${localStorage.getItem("token")}`
    : null;
if (getAuthToken !== null) {
  const authInterceptor = (config) => {
    config.headers["Authorization"] = getAuthToken();
    return config;
  };
  axios.interceptors.request.use(authInterceptor);
}
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // handle error
    const vm = new Vue();
    if (error.response.status === 401) {
      store.dispatch("auth/logout").then(() => {
        router.push({ name: "login" });
      });

      //alert(error.response.data.message);
    } else if (error.response.status === 403) {
      router.push({ name: "error-403" });
      //alert(error.response.data.message);
    } else if (error.response.status === 400) {
      //alert(error.response.data.message);
      // vm.$bvToast.toast(i18n.t("toastification.errorOccurred"), {
      //   title: i18n.t("toastification.error"),
      //   variant: "danger",
      //   solid: true,
      // });
    } else if (error.response.status === 422) {
      vm.$bvToast.toast(error.response.data.message, {
        title: i18n.t("toastification.error"),
        variant: "danger",
        solid: true,
      });
    }
    return Promise.reject(error);
  }
);

export default axios;
